import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconTarget } from "@tabler/icons-react";
import { getSubIndustryLabel } from "@/components/shared/constants/general.const";
import type { SectorEcosystemOverview } from "../../../../../../shared/sectorEcosystemOverview";
import type { SectorListFooterLink } from "../sectorCompaniesList.const";
import {
  getStaticSectorOpportunitySubIndustries,
  MIN_SECTOR_OPPORTUNITIES_LIST_COMPANIES,
} from "../sectorEcosystem.const";
import SectorDashboardCard from "./SectorDashboardCard";

type SectorOpportunitiesCardProps = {
  overview: SectorEcosystemOverview;
} & SectorListFooterLink;

export default function SectorOpportunitiesCard({ overview, footerTo, footerLinkState }: SectorOpportunitiesCardProps) {
  const opportunityRows =
    overview.opportunities.length > 0
      ? overview.opportunities.map((row) => row.subIndustry)
      : getStaticSectorOpportunitySubIndustries(overview.slug);

  const opportunitiesListReady = overview.hero.companies >= MIN_SECTOR_OPPORTUNITIES_LIST_COMPANIES;

  return (
    <SectorDashboardCard
      title="Opportunities"
      subtitle="What companies are looking for."
      footerLabel="View All Opportunities"
      footerComingSoon={!opportunitiesListReady}
      footerTo={opportunitiesListReady ? footerTo : undefined}
      footerLinkState={opportunitiesListReady ? footerLinkState : undefined}
    >
      <Stack gap="xs">
        {opportunityRows.map((subIndustry) => (
          <Group key={subIndustry} gap="xs" wrap="nowrap">
            <ThemeIcon size={24} radius="md" variant="light" color="blue">
              <IconTarget size={12} />
            </ThemeIcon>
            <Text size="sm" truncate>
              {getSubIndustryLabel(subIndustry)}
            </Text>
          </Group>
        ))}
      </Stack>
    </SectorDashboardCard>
  );
}
